import { render } from "./AssetImagesModal.vue?vue&type=template&id=bd71ffc4&scoped=true&ts=true"
import script from "./AssetImagesModal.vue?vue&type=script&lang=ts"
export * from "./AssetImagesModal.vue?vue&type=script&lang=ts"

import "./AssetImagesModal.vue?vue&type=style&index=0&id=bd71ffc4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd71ffc4"]])

export default __exports__